module.exports = __webpack_public_path__ + "img/New PACI Flow - Enable Authentication - 8.534b8559.png";